import {
  AfterViewInit,
  Component,
  input,
  Input,
  output,
  QueryList,
  Type,
  ViewChildren,
  ViewContainerRef,
} from '@angular/core';
import { MatCard } from '@angular/material/card';
import { MatTab, MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';

export interface DynamicComponent {
  data?: object | null;
}

@Component({
  selector: 'app-tabs-layout',
  templateUrl: './tabs-layout.component.html',
  styles: [
    `
      :host {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    `,
  ],
  imports: [MatCard, MatTabGroup, MatTab],
})
export class TabsLayoutComponent implements AfterViewInit {
  @Input() public tabs: {
    component: Type<DynamicComponent>;
    title: string;
    data?: unknown;
    disabled?: boolean;
  }[] = [];

  public selectedTabIndex = input<number>(0);
  public tabChange = output<number>();

  @ViewChildren('tabContent', { read: ViewContainerRef })
  public tabContent!: QueryList<ViewContainerRef>;

  public ngAfterViewInit(): void {
    this.loadComponent(this.selectedTabIndex());
  }

  public loadComponent(index: number): void {
    const viewContainerRef = this.tabContent.toArray()[index];

    if (viewContainerRef) {
      viewContainerRef.clear();

      const component = this.tabs[index].component;
      const componentRef = viewContainerRef.createComponent(component);

      if (this.tabs[index]?.data) {
        componentRef.instance.data = this.tabs[index]?.data;
      }
    }
  }

  public onTabChange(event: MatTabChangeEvent): void {
    this.loadComponent(event.index);
    this.tabChange.emit(event.index);
  }
}
